import React, { useLayoutEffect, useContext, useRef } from 'react';
import PropTypes from 'prop-types';

import DashboardContext from '#/context';
import useWidget from '#/hooks/useWidget';
import Loader from '#/components/Loader';
import styles from './styles.module.css';
// import { Colors } from '#/utils/utils';

const getFontColor = (fColor, fontColor) => {
  return fColor ? fColor : fontColor
}

const getBgColor = (bgColor, backgroundColor) => {
  return bgColor ? bgColor : backgroundColor
}

function LabelValue({ dashboardWidgetId, endpoint, bgColor, fColor, widgetBindDtos, auxiliaryOptionsDto }) {
  const { filters, localFilters, date, stateDashboard, polling } = useContext(
    DashboardContext
  );
  const uiStyle = {
    fontColor: '#5d5d5d',
    backgroundColor:'#fff',
    titleContainer: '#f6f8f8',
    borderTitleContainer: '#ddd',
    fontWeight: '500',
    fontSize: '0.9rem'
  }

  const { serviceData } = useWidget(
    endpoint,
    filters,
    localFilters,
    date,
    polling,
    dashboardWidgetId,
    null,
    null,
    widgetBindDtos, 
    auxiliaryOptionsDto
  );

  useLayoutEffect(() => {
    renderStyle();
  });

  const widget = useRef(null);

  const renderStyle = () => {
    if (widget.current) {
    
      if (serviceData) {
        uiStyle.fontColor = getFontColor(fColor,  serviceData.fontColor);
        uiStyle.backgroundColor = getBgColor(bgColor, serviceData.backgroundColor);
        uiStyle.titleContainer = uiStyle.backgroundColor;
        uiStyle.borderTitleContainer = uiStyle.backgroundColor;
        uiStyle.fontWeight = 'bold';
        uiStyle.fontSize = '1rem';
      }
      
      
      const widgetWrapper = widget.current.parentNode;
      const width = widgetWrapper.offsetWidth * 0.1;
      const height = widgetWrapper.offsetHeight * 0.1;

      widgetWrapper.parentNode.style.borderRadius = '8px';

      widgetWrapper.style.color = uiStyle.fontColor;
      widgetWrapper.children[0].style.color = uiStyle.fontColor;
      widgetWrapper.style.backgroundColor = uiStyle.backgroundColor;
      widgetWrapper.children[0].style.backgroundColor = uiStyle.titleContainer;
      widgetWrapper.children[0].style.borderBottomColor = uiStyle.borderTitleContainer;
      
      widgetWrapper.children[0].style.fontWeight = uiStyle.fontWeight;
      widgetWrapper.children[0].style.fontSize = uiStyle.fontSize;
      widgetWrapper.style.fontSize = `${width + height}px`;
      if (stateDashboard.edit) {
        const editTopWrapper = widgetWrapper.parentNode.children[0];
        const configButton = editTopWrapper.children[0];
        const configButtonSvg = configButton.children[0];
        const closeButton = editTopWrapper.children[1];
        const resizeButton = widgetWrapper.parentNode.children[2];

        closeButton.style.backgroundColor = uiStyle.fontColor;
        configButtonSvg.style.fill = uiStyle.fontColor;
        resizeButton.style.backgroundColor = uiStyle.fontColor;
      }
    }
  };

  return (serviceData && !serviceData.loading) ? (
    <div className={styles.wrapper} ref={widget}>
      <p className={styles.value}>
        {serviceData.formatedValue && serviceData.formatedValue.length ? serviceData.formatedValue 
          : serviceData.value ? serviceData.value : 0}
      </p>
    </div>
  ) : (
    <div className={styles.wrapper} ref={widget}>
      <Loader />
    </div>
  );
}

LabelValue.propTypes = {
  id: PropTypes.string.isRequired,
  endpoint: PropTypes.shape({
    endpointType: PropTypes.string.isRequired,
    endpointUrl: PropTypes.string.isRequired,
  }),
};

export default LabelValue;
